/**
 * Toastr configuration module
 * Handles initialization and configuration of toastr notifications
 */

import { CONFIG } from '../core/config.js';

/**
 * Initializes toastr with custom configuration options
 * Sets up global toastr settings for consistent notification behavior
 *
 * @function initializeToastr
 * @description Configures toastr with predefined settings including positioning,
 * timing, animations, and display options for the application
 *
 * Configuration includes:
 * - Position: Top full width
 * - Timeout: 5 seconds with 1 second extended timeout
 * - Animations: Fade in/out with swing easing
 * - Progress bar enabled
 * - No close button or debug mode
 */
export function initializeToastr() {
    if (typeof toastr === 'undefined') {
        // Toastr is not available - this is expected in some environments
        return;
    }

    toastr.options = {
        closeButton: false,
        debug: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: CONFIG.TOASTR.POSITION,
        preventDuplicates: false,
        onclick: null,
        showDuration: CONFIG.TOASTR.SHOW_DURATION.toString(),
        hideDuration: CONFIG.TOASTR.HIDE_DURATION.toString(),
        timeOut: CONFIG.TOASTR.TIMEOUT.toString(),
        extendedTimeOut: CONFIG.TOASTR.EXTENDED_TIMEOUT.toString(),
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut'
    };
}
